export default __webpack_public_path__ + "static/media/3.04d01d59.jpg";